import styled from "styled-components"
import { NEUTRAL_100, BLACK, GRAYSCALE_400, GRAYSCALE_500, PALE_BLUE, BLUE } from "@styles/colors"
import { INTER } from "@styles/fonts"
import { safeAreaInset } from "@lib/telegram"

// Main container styles
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding-bottom: 8px;
`

// Keyboard and button container
export const BottomContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding-bottom: ${safeAreaInset().bottom - 8 || 0}px;
`

// P2PTransferInputAmount styles
export const InputAmountContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  align-items: center;
  padding: 16px 12px;
  border: 1px solid ${NEUTRAL_100};
  border-radius: 12px;
`

export const InputTitle = styled.span`
  font-family: ${INTER.regular};
  color: ${BLACK};
`

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${NEUTRAL_100};
`

// BalanceInformation styles
export const BalanceContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`

export const BalanceText = styled.span`
  font-family: ${INTER.regular};
  color: ${GRAYSCALE_400};
`

export const BalanceAmount = styled.span`
  color: ${GRAYSCALE_500};
  font-family: ${INTER.bold};
  margin-left: 4px;
`

// AmountDisplay styles
export const AmountContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  background-color: ${PALE_BLUE};
  padding: 4px 0;
  border-radius: 12px;
  position: relative;
`

export const AmountText = styled.span`
  color: ${BLACK};
  font-family: ${INTER.bold};
  font-size: 20px;
`

export const MaxButtonContainer = styled.div`
  position: absolute;
  cursor: pointer;
  right: 8px;
  z-index: 10000;
`

export const MaxButtonText = styled.span`
  color: ${BLUE};
  font-family: ${INTER.semiBold};
  font-size: 14px;
`